<template>
    <div class="w-full h-full">
      <div class="w-full h-full flex relative">
        <div class="w-full flex flex-col flex-1 h-full ">
          <div class="w-full md:px-8 px-4 ">
            <div class="w-full h-[75%] py-3">
              <div>
                <p>{{ $t('vousavezenregistre') }}</p>
              </div> 
              <div>
                <p class="md:text-[3rem] text-[2rem] font-semibold">{{ user.nbr_article < 10 && (user.nbr_article >0) ? '0'+ user.nbr_article:user.nbr_article }} {{ $t('articles') }}</p>
              </div>
            </div>
            <div class="w-full nav h-[25%]  space-x-2 flex flex-row scrollbar-hide overflow-x-auto">
              <router-link to="/mes-articles" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
                <p class="mx-auto">{{ $t('tout') }}</p>
              </router-link> 
              <router-link to="/en-vente" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
                <p class="mx-auto">{{ $t('envente') }}</p>
              </router-link>
              <router-link to="/en-cour-de-vente" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
                <p class="mx-auto">{{ $t('encourdevente') }}</p>
              </router-link>
              <router-link to="/vendus" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
                <p class="mx-auto">{{ $t('vendus') }}</p>
              </router-link>
              <router-link to="/non-vendus" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
                <p class="mx-auto">{{ $t('nonvendus') }}</p>
              </router-link>
            </div>
          </div>
          <div class="h-full w-full overflow-hidden">
            <router-view name="fourth"></router-view>
          </div>
        </div>
        <div :style="drapStat=='no' ? `transform: translateX(${widthStat}px)`:drapStat ? 'transition-duration: 700ms; transform: translateX(0)':`transition-duration: 700ms; transform: translateX(${widthStat}px)`" class=" flex absolute right-0 xl:static h-full py-3 ease-in z-30">
          <div @click="drapDropStat" class="h-full w-8 xl:hidden flex items-center">
            <div class="w-full cursor-pointer h-20 rounded-tl-md rounded-bl-md bg-black bg-opacity-80 flex justify-center items-center">
              <img :class="drapStat && (drapStat != 'no') ? 'rotate-180 delay-700':'rotate-0 delay-700'" class="object-contain transform transition duration-300 ease-in" src="/icons/chevron_left.png" alt="" srcset="">
            </div>
          </div>
          <div id="stat" class="flex flex-col bg-white">
            <div class=" relative px-2">
              <div class="w-full ">
                <form @submit.prevent="search" class="mx-auto w-full relative rounded-full overflow-hidden ">
                  <button :disabled="disable ? true:false" type="submit" class="bg-[#FF9900] w-[20%] h-full absolute right-0 flex items-center">
                    <img class="w-3 h-3 mx-auto" src="/icons/search.png" alt="" srcset="">
                  </button>
                  <input @click="goPageSearch" v-model="articleSearch" @keyup="searchRefresh" type="text" required id="input-group-1" class=" bg-gray-100 border border-white w-[80%] rounded-l-full  text-sm  focus:ring-[#FF9900] focus:border-[#FF9900] block  p-2  placeholder-gray-400 focus:outline-none" :placeholder="$t('recherchez')" :disabled="disable ? true:false"/> 
                </form>
              </div>
            </div>
            <div class=" flex h-full items-center">
              <div>
                <div class="w-full flex">
                  <p class="mx-auto font-semibold">{{ $t('statistiquesdesarticles') }}</p>
                </div>
                <div class="flex mx-auto">
                  <Doughnut :data="nbrVendu == 0 && nbrNonVendu == 0 && nbrEnVente == 0 && nbrEnCourDeVente == 0 ? chartDataEmpty:chartData" :options="chartOptions" />
                </div>
                <div class="w-full flex mt-5">
                  <p class="mx-auto text-sm">{{ $t('gainstotaldesarticlesenventes') }}</p>
                </div>
                <div class="flex mt-1">
                  <div class="flex items-center mx-auto space-x-2">
                    <img class="h-6" src="/icons/icons8_money_bag@2x.png" alt="" srcset="">
                    <p class="text-[#FF9900]">{{ $t('gains') }} :</p>
                    <div class="flex space-x-1">
                      <div class="h-auto flex items-center">
                        <p class="font-serif"> <span class="font-semibold">{{ transformAmount(montantTotalEnventes) }}</span></p>
                      </div>
                      <div class="h-auto flex items-center">
                        <svg class="h-6 fill-black" version="1.0" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 433.000000 577.000000"
                          preserveAspectRatio="xMidYMid meet">
    
                              <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                              stroke="none">
                              <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                              36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                              -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                              496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                              -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                              91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                              -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                              156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                              -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                              -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                              83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                              -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                              195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                              114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                              172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                              -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                              -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                              124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                              33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                              m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                              c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                              -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                              -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                              m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                              -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                              0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                              -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                              -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                              44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                              -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                              </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
  import { Doughnut } from 'vue-chartjs'

  ChartJS.register(ArcElement, Tooltip, Legend)

  export default {
    components: { Doughnut },
    data(){
      return{
        user:'',
        articleSearch:'',
        disable:false,
        drapStat: 'no',
        widthStat:0,
        nbrNonVendu:0,
        nbrVendu:0,
        nbrEnVente:0,
        nbrEnCourDeVente:0,
        montantTotalEnventes:0,
      }
    },
    watch: {
      requestMontantTotalEnventes: {
        handler(newValue) {
          this.montantTotalEnventes = newValue
          },
        deep: true
      },
      requestNbrVendu: {
        handler(newValue) {
          this.nbrVendu = newValue
          },
        deep: true
      },
      requestNbrNonVendu: {
        handler(newValue) {
          this.nbrNonVendu = newValue
          },
        deep: true
      },
      requestNbrEnVente: {
        handler(newValue) {
            this.nbrEnVente = newValue
          },
        deep: true
      },
    },
    beforeRouteLeave() {
      window.emitter.off("disableInputSearchMyArticle")
    },
    created(){
      window.emitter.on("disableInputSearchMyArticle", (value) => {
        this.disable = value
      })
    },
    mounted(){
      this.user = this.$store.state.dataAccueil[0]
      this.articleSearch = this.$store.state.elementSearch['myArticleSearch']

      if(screen.width < 1280){
        this.widthStat = document.getElementById('stat').offsetWidth
      }
      if(this.$store.state.nbrVendu > 0 || this.$store.state.nbrNonVendu  > 0 || this.$store.state.nbrEnVente > 0 || this.$store.state.nbrEnCourDeVente > 0 ){
        this.nbrVendu = this.$store.state.nbrVendu 
        this.nbrNonVendu = this.$store.state.nbrNonVendu 
        this.nbrEnVente = this.$store.state.nbrEnVente 
        this.nbrEnCourDeVente = this.$store.state.nbrEnCourDeVente
        this.montantTotalEnventes = this.$store.state.montantTotalEnventes
      }else{
        this.axios.get(this.requestHttp + 'my_stat',{
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
            },
        }).then(({data}) => {
          this.$store.state.nbrVendu = data[0]
          this.$store.state.nbrNonVendu = data[1]
          this.$store.state.nbrEnVente = data[2]
          this.$store.state.nbrEnCourDeVente = data[3]
          this.$store.state.montantTotalEnventes = data[4]
        })
        .catch((error) => {
          console.log(error) 
        });
      }
    },
    methods:{
      goPageSearch(){
        this.$router.push('/mes-articles');
      },
      searchRefresh(){
        if(this.articleSearch.length == 0){
          window.emitter.emit("searchElementInMyBoutique", this.articleSearch)
        }
      },
      search(){
        if(this.articleSearch.length > 0){
          window.emitter.emit("searchElementInMyBoutique", this.articleSearch)
        }
      },
      drapDropStat(){
        if(this.drapStat == false || this.drapStat == 'no'){
          this.drapStat = true
        }else{
          this.drapStat = false
        }
      },
      transformAmount(value){
        var result = ''
        if(value > 0){
          var text = Math.round(value).toString()
          var countElement = ''
          for (let i = 1; i <= text.length; i++) {
            result = text[text.length - i] + result
            countElement += text[text.length - i]
            if(countElement.length < text.length && countElement.length%3 == 0){
              result = (localStorage.getItem('langue') == 'fr' ? ',':'.') + result
            }
          }
        }else{
          result = value
        }
        
        return result
      },
    },
    computed:{
      requestToutMesArticles(){
        return this.$store.state.toutMesArticles
      },
      requestAccueil(){
        return this.$store.state.dataAccueil
      },
      requestHttp(){
        return this.$store.state.api
      },
      requestNbrVendu(){
        return this.$store.state.nbrVendu
      },
      requestNbrNonVendu(){
        return this.$store.state.nbrNonVendu
      },
      requestNbrEnVente(){
        return this.$store.state.nbrEnVente
      },
      requestMontantTotalEnventes(){
        return this.$store.state.montantTotalEnventes
      },
      chartDataEmpty(){ 
        return  {
          labels: ['En vente','En cour de vente','Vendus','Non-vendus'],
          datasets: [{
            backgroundColor: ['#FFFF00', '#00D8FF' , '#008000', '#DD1B16'],
            data:[0, 0, 0, 1]
          }],
        }
      },
      chartData(){ 
        return  {
          labels: ['En vente','En cour de vente','Vendus','Non-vendus'],
          datasets: [{
            backgroundColor: ['#FFFF00', '#00D8FF' , '#008000', '#DD1B16'],
            data:[this.$store.state.nbrEnVente, this.$store.state.nbrEnCourDeVente, this.$store.state.nbrVendu, this.$store.state.nbrNonVendu]
          }],
        }
      },
      chartOptions() { 
        return {
          responsive: true,
          maintainAspectRatio: false
        }
      },
    }
  }
  </script>
  
  <style>
    .nav .router-link-exact-active {
      border-color: #FF9900;
      border-bottom-width: 4px;
      color: black;
    }
  </style>